import React, { useEffect, useRef } from 'react';
import { NumberInput, Tooltip } from 'components/common';

const NumberFormField = ({ config, value, setValue, register, errors, readOnly, disabled, integerOnly, options, values }) => {

  // The recompute listener is installed once but fires long after mount; a ref keeps the latest form
  // values reachable to it (to read sibling fields such as the guillotine "cutting to size"
  // checkboxes) without re-subscribing on every render.
  const valuesRef = useRef(values);
  valuesRef.current = values;

  // Recompute this field's value when a sibling field announces a change (the guillotine checkboxes
  // recomputing the default cut count). The recompute expression reads `options` and the live form
  // `values` by name, the same variables the rest of the sections.yml expressions use; the sibling's
  // own change already schedules the section's debounced post, so the recomputed value rides along in
  // that single post.
  useEffect(() => {
    if (config.recompute_on_events == undefined) { return undefined; }

    const recompute = () => {
      const values = valuesRef.current;
      setValue(config.name, eval(config.recompute_value_eval));
      // Re-price the section with the recomputed value (the sibling change that triggers a recompute
      // does its own post, but the mount-time recompute below has no such trigger).
      setValue('updated_at', Date.now());
    };

    // On page load the saved value can be stale: it was derived from sibling inputs (the guillotine
    // checkboxes) that reset to their defaults on load, so the two fall out of sync. Recompute once
    // from the current inputs, then on every announced change.
    recompute();

    config.recompute_on_events.forEach((eventName) => document.addEventListener(eventName, recompute));
    return () => { config.recompute_on_events.forEach((eventName) => document.removeEventListener(eventName, recompute)); };
  }, []);

  const onChange = (e) => {
    setValue(config.name, e.target.value);
    if(config.publish_on_change_key != undefined) {
      var event = new CustomEvent(config.publish_on_change_key, { "detail": e.target.value });
      document.dispatchEvent(event);
    }
  }

  return (
    <tr>
      <td>
        {t(config.label)} { config.tooltip_text != undefined && <Tooltip title={t(config.tooltip_text)} /> }
        {config.helper_text != undefined && (
          <><br /><small className="form-text text-muted" dangerouslySetInnerHTML={{ __html: t(config.helper_text) }} /></>
        )}
      </td>
      <td align="right">
        <NumberInput
          name={config.name}
          placeholder={config.placeholder}
          register={register}
          errors={errors}
          class_name={config.class_name}
          integerOnly={integerOnly}
          validators={config.validators != undefined ? config.validators : []}
          value={value}
          readOnly={readOnly}
          onChange={onChange}
        />
      </td>
    </tr>
  )
}
export default NumberFormField;
